<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/translation_example.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("tran.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"tasks":[{"text":"I’m a big fan of Trustami and use their affordable AI services.","lang":"DE"}]}
                    </p>

                    <h4 class="font-weight--light">{{ $t("tran.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"tasks":[{"title":"Summary","body":"Ich bin ein großer Fan von Trustami und nutze ihre erschwinglichen KI-Dienste.","has_error":false}]}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
